<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="$t('anyform.selectImage')">
              <b-form-file v-model="image" accept="image/*"></b-form-file>
            </b-form-group>

            <b-form-group :label="`${$t('anyform.name')} (EN)`">
              <b-form-input type="text" v-model="$v.createForm.name_en.$model" :state="!$v.createForm.name_en.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.name_en.required">
                {{ $t('formErrors.enterName') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('anyform.name')} (RU)`">
              <b-form-input type="text" v-model="$v.createForm.name_ru.$model" :state="!$v.createForm.name_ru.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.name_ru.required">
                {{ $t('formErrors.enterName') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              :disabled="isLoading"
              :class="{
                'btn-multiple-state mt-2': true,
                'show-spinner': isLoading
              }"
            >
              <span class="spinner d-inline-block">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
              <span class="label">
                {{ $t('buttons.save') }}
              </span>
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
const { required } = require('vuelidate/lib/validators')

export default {
  data: () => ({
    isLoading: false,
    image: null,
    createForm: {
      name_en: '',
      name_ru: ''
    }
  }),
  validations: {
    createForm: {
      name_en: { required },
      name_ru: { required }
    }
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = Object.assign({}, this.createForm)
        if (this.image) {
          payload.image = this.image
        }
        this.$store.dispatch('productSections/createProductSection', {
          payload,
          vm: this
        })
      }
    }
  }
}
</script>
